module.exports = "<nav class=\"second-nav deep-orange\">\n  <div class=\"nav-wrapper container\">\n    <a routerLink=\"/\" class=\"breadcrumb waves-effect waves-light\">\n      <i class=\"large material-icons left \">arrow_back</i>Voltar\n    </a>\n  </div>\n</nav>"


//////////////////
// WEBPACK FOOTER
// C:/Users/hyago/Desktop/SiteEventos/src/app/jges/cabecajges/cabecajges.component.html
// module id = ../../../../../src/app/jges/cabecajges/cabecajges.component.html
// module chunks = main